import { useState } from "react";
import Reveal from "@/components/site/Reveal";
import { ArrowUpRight } from "lucide-react";

const STRUTTURE = [
  {
    id: "scorzamara",
    units: "4 lodge",
    name: "Scorzamara",
    photo: "/images/strutture/scorzamara.jpg",
    zone: "Melilli (SR)",
    type: "Country lodge con piscine private",
    score: "9,5",
    scoreLabel: "Eccezionale",
    reviews: "61 recensioni",
    url: "https://www.booking.com/hotel/it/scorzamara.it.html",
  },
  {
    id: "villa-sambucia",
    name: "Villa Sambucia",
    photo: "/images/strutture/villa-sambucia.jpg",
    zone: "Siracusa",
    type: "Villa privata con piscina e idromassaggio",
    score: "9,8",
    scoreLabel: "Eccezionale",
    reviews: "19 recensioni",
    url: "https://www.booking.com/hotel/it/dimora-sambucia.html",
  },
  {
    id: "tre-e-14",
    units: "4 camere",
    name: "B&B Tre e 14",
    photo: "/images/strutture/tre-e-14.jpg",
    zone: "Siracusa",
    type: "B&B tra Ortigia e il Parco Archeologico",
    score: "9,4",
    scoreLabel: "Favoloso",
    reviews: "116 recensioni",
    url: "https://www.booking.com/hotel/it/b-amp-b-tre-e-14.html",
  },
  {
    id: "isola-charm",
    units: "11 camere",
    name: "Isola Charm",
    photo: "/images/strutture/isola-charm.jpg",
    zone: "Plemmirio · Siracusa",
    type: "B&B con piscina, immerso nella natura",
    score: "8,9",
    scoreLabel: "Eccellente",
    reviews: "569 recensioni",
    url: "https://www.booking.com/hotel/it/villa-isola-siracusa.it.html",
  },
  {
    id: "etna-mare-brucoli",
    units: "4 appartamenti",
    name: "Etna Mare Brucoli",
    photo: "/images/strutture/etna-mare-brucoli.jpg",
    zone: "Brucoli · Augusta",
    type: "Appartamenti con piscina e vista mare",
    score: "9,2",
    scoreLabel: "Favoloso",
    reviews: "9 recensioni",
    url: "https://www.booking.com/hotel/it/etna-mare-apartments.html",
  },
  {
    id: "open-sicily-quattro-canti",
    units: "6 appartamenti",
    name: "Open Sicily Quattro Canti",
    photo: "/images/strutture/open-sicily-quattro-canti.jpg",
    zone: "Quattro Canti · Palermo",
    type: "Residence di appartamenti nel centro storico — la mia società",
    score: "8,7",
    scoreLabel: "Eccellente",
    reviews: "624 recensioni",
    url: "https://www.booking.com/hotel/it/open-sicily-residence.it.html",
  },
  {
    id: "open-sicily-homes-stazione",
    units: "9 appartamenti",
    name: "Open Sicily Homes",
    photo: "/images/strutture/open-sicily-homes-stazione.jpg",
    zone: "La Kalsa · Palermo",
    type: "Appartamenti in palazzo storico, a due passi dalla Stazione Centrale — la mia società",
    score: "8,6",
    scoreLabel: "Eccellente",
    reviews: "871 recensioni",
    url: "https://www.booking.com/hotel/it/open-sicily-homes-residence-gran-palermo.it.html",
  },
  {
    id: "archimede-charm",
    units: "6 camere",
    name: "Archimede Vacanze Charm B&B",
    photo: "/images/strutture/archimede-charm.jpg",
    zone: "Ortigia · Siracusa",
    type: "B&B in palazzo storico su Piazza Archimede",
    score: "9,0",
    scoreLabel: "Favoloso",
    reviews: "263 recensioni",
    url: "https://www.booking.com/hotel/it/archimede-vacanze.html",
  },
];

export const UNITA_TOTALI = STRUTTURE.reduce((n, s) => n + (parseInt(s.units, 10) || 0), 0);

export default function Strutture() {
  const [showAll, setShowAll] = useState(false);
  return (
    <section id="strutture" data-testid="strutture-section" className="border-b border-[#DCD7C9] bg-[#F7F4EC] py-12 sm:py-28 lg:py-36">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal>
          <p className="section-kicker">Alcune delle strutture che seguo</p>
          <h2 className="mt-4 max-w-3xl font-heading text-2xl font-black uppercase leading-[1.05] tracking-tight text-[#12100E] sm:text-4xl lg:text-5xl">
            Non fidarti di me. Guarda loro.
          </h2>
          <p className="mt-4 max-w-2xl text-base font-light leading-relaxed text-[#52525B] sm:mt-6 sm:text-lg">
            Alcune delle strutture che seguo in Sicilia. Non ti chiedo di credermi: cercale su Booking, guarda gli annunci, leggi le recensioni. Il mio lavoro è tutto lì.
          </p>
          <p className="mt-6 section-kicker sm:mt-10">Per ognuna di loro, ogni giorno</p>
          <div className="mt-3 grid sm:mt-5 max-w-4xl gap-x-10 sm:grid-cols-2">
            {[
              "Curo tutto l'online: Booking, Airbnb, gli altri portali e il sito web, con prezzi coerenti ovunque",
              "Strategia prezzi costruita su analisi di mercato e occupazione",
              "Controllo giornaliero di prezzi e occupazione",
              "I prezzi si muovono seguendo la domanda, non l'abitudine",
              "Report settimanali chiari, in parole semplici",
              "I dati accumulati oggi diventano la strategia di domani",
            ].map((item, i) => (
              <p key={item} data-testid={`strutture-attivita-${i + 1}`} className={`${i >= 3 ? "hidden sm:flex" : "flex"} items-baseline gap-4 border-t border-[#DCD7C9] py-2.5 sm:py-4 text-sm font-light leading-relaxed text-[#52525B] last:border-b sm:text-base sm:[&:nth-last-child(2)]:border-b`}>
                <span className="shrink-0 font-heading font-black text-[#E05A2C]">—</span>
                {item}
              </p>
            ))}
          </div>
        </Reveal>

        <div className="mt-8 grid gap-4 sm:mt-14 sm:gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {STRUTTURE.map((s, i) => (
            <Reveal key={s.id} delay={i * 0.08} className={`h-full ${i >= 2 && !showAll ? "hidden sm:block" : ""}`}>
              <a
                href={s.url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`struttura-card-${s.id}`}
                className="group flex h-full flex-col border border-[#DCD7C9] bg-white transition-colors duration-300 hover:border-[#E05A2C]"
              >
                <div className="overflow-hidden border-b border-[#DCD7C9]">
                  <img
                    src={s.photo}
                    alt={`${s.name} — ${s.zone}`}
                    loading="lazy"
                    className="aspect-[2/1] w-full object-cover transition-transform duration-700 group-hover:scale-[1.04] sm:aspect-[4/3]"
                  />
                </div>
                <div className="flex flex-1 flex-col p-4 sm:p-6">
                  <div className="flex items-baseline justify-between gap-3">
                    <p className="font-heading text-lg font-black uppercase tracking-tight text-[#12100E] sm:text-xl">{s.name}</p>
                    <ArrowUpRight className="h-5 w-5 shrink-0 text-[#A89F91] transition-colors duration-300 group-hover:text-[#E05A2C]" />
                  </div>
                  <p className="mt-1 font-mono text-xs uppercase tracking-widest text-[#E05A2C] sm:text-xs">{s.units ? `${s.units} · ` : ""}{s.zone}</p>
                  <p className="mt-3 hidden flex-1 text-sm leading-relaxed text-[#52525B] sm:block">{s.type}</p>
                  <p data-testid={`struttura-score-${s.id}`} className="mt-3 flex items-baseline gap-2 border-t border-[#DCD7C9] pt-3 sm:mt-5 sm:pt-4">
                    <span className="font-heading text-2xl font-black tracking-tighter text-[#B45309]">{s.score}</span>
                    <span className="font-mono text-xs uppercase tracking-widest text-[#686054]">
                      {s.scoreLabel} su Booking · {s.reviews}
                    </span>
                  </p>
                </div>
              </a>
            </Reveal>
          ))}
        </div>

        {!showAll && (
          <button
            data-testid="strutture-show-all"
            onClick={() => setShowAll(true)}
            className="mt-4 flex min-h-[48px] w-full items-center justify-center rounded-full border border-[#12100E] px-6 text-sm font-medium text-[#12100E] transition-colors duration-300 hover:border-[#E05A2C] hover:text-[#E05A2C] sm:hidden"
          >
            Mostra tutte le {STRUTTURE.length} strutture
          </button>
        )}

        <Reveal delay={0.2}>
          <p className="mt-8 font-mono text-xs uppercase tracking-widest text-[#686054] sm:text-xs">
            Punteggi e recensioni veri: clicca una struttura e verificali su Booking.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
